var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 65,
    viewBox: "0 0 68 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 65,
    rx: 10,
    fill: "#EEF8F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0604 51.4899C32.517 51.7568 32.7453 51.8904 33.0675 51.9597C33.3177 52.0134 33.6823 52.0134 33.9325 51.9597C34.2547 51.8904 34.483 51.7568 34.9396 51.4899C38.9574 49.14 50 41.7583 50 31.6092V20.4437C50 19.2901 50 18.7132 49.7785 18.2736C49.5821 17.8838 49.2754 17.5727 48.8889 17.3713C48.4531 17.144 47.868 17.1371 46.6975 17.1232C40.5686 17.0506 37.0343 16.5432 33.5 13C29.9657 16.5432 26.4314 17.0506 20.3025 17.1232C19.1321 17.1371 18.5469 17.144 18.111 17.3713C17.7245 17.5727 17.4178 17.8838 17.2215 18.2736C17 18.7132 17 19.2901 17 20.4437V31.6092C17 41.7583 28.0425 49.14 32.0604 51.4899Z",
    stroke: "#16A249",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verified-icon.ce3a64edf109fc36c4155adc83e4d5f5.svg";
export { ForwardRef as ReactComponent };